import React, { useState, useEffect } from 'react';
import './LegalPage.css';

function PrivacyPolicyPage() {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch('/polityka-prywatnosci.txt')
      .then(response => {
        if (!response.ok) throw new Error('Nie udało się załadować polityki prywatności');
        return response.text();
      })
      .then(text => setContent(text))
      .catch(err => setError(err.message))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <div className="legal-page-container">
      <div className="legal-page-card">
        <h1 className="legal-page-title">Polityka prywatności</h1>
        {isLoading && <div className="legal-page-loading">Ładowanie...</div>}
        {error && <div className="legal-page-error">{error}</div>}
        {content && <div className="legal-page-content">{content}</div>}
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
